/**
 * The Audio Studio page behind its access rule (staff only for now, see `useAudioStudioAccess`): a spinner while
 * staff is unknown, the studio for staff, and for everyone else a short note with a way back to Ad Studio.
 */
import { Loader2, Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AudioStudioPage } from './AudioStudioPage';
import { useAudioStudioAccess } from './queries';

export function AudioStudioGate({ onNavigate }: { onNavigate?: (page: string) => void }) {
  const access = useAudioStudioAccess();
  if (access === null) {
    return (
      <div role="status" aria-label="Loading Audio Studio" className="flex min-h-[50vh] items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-[#98a2b3]" aria-hidden />
      </div>
    );
  }
  if (!access) {
    return (
      <div className="mx-auto flex min-h-[50vh] max-w-md flex-col items-center justify-center gap-3 px-4 text-center">
        <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#f2f4f7]"><Lock className="h-5 w-5 text-[#667085]" aria-hidden /></span>
        <h1 className="text-[18px] text-[#101828]" style={{ fontWeight: 600 }}>Audio Studio isn't available yet</h1>
        <p className="text-[14px] leading-5 text-[#667085]">It's in early access with the Beatly team. Your account manager can tell you when it opens.</p>
        {onNavigate && <Button variant="outline" onClick={() => onNavigate('ad-studios')}>Back to Ad Studio</Button>}
      </div>
    );
  }
  return <AudioStudioPage />;
}
